export default {
  pages: {
    key: 'title',
    data: [
      { title: 'Agenda', route: { name: 'pedagogic-calendar' }, icon: 'CalendarIcon', isBookmarked: true },
    ],
  }
}
